var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard_container"},[_c('v-icon',{staticClass:"wizard_icon mb-4",attrs:{"size":"100","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('div',{staticClass:"wizard_text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }